import { Button } from '@clearcover/atlas';
import React from 'react';
import styles from './styles.module.css';

type Props = {
  onTryAgainClick: () => void;
};

export const Error: React.FC<Props> = ({ onTryAgainClick }) => {
  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <div className={styles.error}>
          <div>There was a problem loading quotes.</div>
          <Button
            isSubmitting={false}
            onClick={() => onTryAgainClick()}
            data-testid="try-again"
          >
            Try Again
          </Button>
          <div>
            If you continue to experience trouble, please contact an Agent
            Advocate at (855) 809-2965.
          </div>
        </div>
      </div>
    </div>
  );
};
